export default __webpack_public_path__ + "CircularCustCapNum-Black.f519b48dc7145eaf7bce6014dafa005b.ttf";